export function PaginationMeta({
  from,
  to,
  total,
}: {
  from?: number;
  to?: number;
  total?: number;
}) {
  return (
    <div className="whitespace-nowrap">
      <span className="hidden md:inline">
        {from} - {to} of
      </span>{' '}
      <span>{total} items</span>
      {/* Showing <span className="font-bold">{from}</span> to&nbsp;
      <span className="font-bold">{to}</span> of&nbsp;
      <span className="font-bold">{total}</span> entries */}
    </div>
  );
}
